<template>
  <div style="padding: 20px">
    <div style="font-size: 16px; font-weight: 600; margin-bottom: 12px">Google OAuth Callback</div>

    <div style="margin-bottom: 8px">
      <div style="font-weight: 600; margin-bottom: 6px">Status</div>
      <pre style="white-space: pre-wrap; background: #f7f7f7; padding: 12px; border-radius: 6px">{{ status }}</pre>
    </div>

    <div style="margin-top: 12px">
      <el-button type="primary" :disabled="!code || loading" @click="handleContinue">Continue</el-button>
      <el-button :disabled="loading" @click="handleBack">Back</el-button>
      <el-button :disabled="loading" @click="handlePrintQuery">Print Query</el-button>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { getToken } from '@/utils/auth'

export default {
  name: 'GoogleOauthCallback',
  data() {
    return {
      status: 'Waiting...',
      code: '',
      error: '',
      redirect: '',
      loading: false,
      queryPayload: {}
    }
  },
  async mounted() {
    this.parseCallbackParams()
  },
  methods: {
    getQueryParam(key) {
      try {
        const q = this.$route && this.$route.query ? this.$route.query : {}
        const v = q[key]
        return Array.isArray(v) ? v[0] : v
      } catch (e) {
        return undefined
      }
    },

    parseCallbackParams() {
      this.code = String(this.getQueryParam('code') || '')
      this.error = String(this.getQueryParam('error') || '')
      this.redirect = String(this.getQueryParam('redirect') || '')

      this.queryPayload = this.normalizeQueryParams()
      console.log('queryPayload', this.queryPayload)
      if (this.error) {
        this.status = `OAuth error: ${this.error}`
        return
      }

      if (!this.code) {
        this.status = 'No code found in URL. Expecting /google-oauth-callback?code=...'
        return
      }

      this.status = '1) Parsed code from URL.\n2) Waiting for user to continue...'
    },

    normalizeQueryParams() {
      try {
        const q = this.$route && this.$route.query ? this.$route.query : {}
        const out = {}
        Object.keys(q).forEach((k) => {
          const v = q[k]
          out[k] = Array.isArray(v) ? (v.length ? v[0] : '') : v
        })
        return out
      } catch (e) {
        return {}
      }
    },

    async handleContinue() {
      try {
        if (!this.code) return
        this.loading = true
        this.status = '2) Calling backend...'

        let token = ''
        try {
          token = getToken() || ''
          if (!token && window.opener && !window.opener.closed) {
            token = window.opener.localStorage ? window.opener.localStorage.getItem('token') : ''
          }
        } catch (e) {
        }

        const resp = await request.post('/front/mail/auth2/back', this.queryPayload, {
          headers: {
            'X-Access-Token': token
          }
        })

        const target = '/google-oauth-demo'
        this.status = `3) Login success. Redirecting to: ${target}`

        try {
          if (window.opener && !window.opener.closed) {
            window.opener.postMessage({ type: 'google_oauth_done', data: resp }, window.location.origin)
            window.close()
            return
          }
        } catch (e) {
        }

        this.$router.replace(target)
      } catch (e) {
        this.status = String(e && (e.message || e))
      } finally {
        this.loading = false
      }
    },

    handlePrintQuery() {
      try {
        const payload = this.normalizeQueryParams()
        console.log('OAuth callback query:', payload)
        this.status = `Current query:\n${JSON.stringify(payload, null, 2)}`
      } catch (e) {
        this.status = String(e && (e.message || e))
      }
    },

    handleBack() {
      this.$router.replace('/google-oauth-demo')
    }
  }
}
</script>
